import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Deadlines = () => {
  return (
    <React.Fragment>
      <SEO title="Important Dates | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Important Dates"
        content="For Authors"
        contentTwo="Deadlines"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <p>
            <h4>Deadlines for ICSI&apos;2025:</h4>
          </p>
          <br />
          <table className="deadline">
            <tbody>
              <tr>
                <th width="200">Event</th>
                <th width="400">Deadline</th>
              </tr>
              <tr>
                <td>
                  <del>
                      Special Session proposals
                  </del>
                </td>
                <td>
                  
                  {/* <del> */}
                    <del>
                  March 15st, 2025
                    </del>
                  {/* </del> */}
                  
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                    Paper submission
                  </del>
                </td>
                <td>
                  <del>
                  March 31st, 2025
                  </del>
                  {/* <br></br> */}
                  
                  {/* <del>
                  April 18th, 2025 (Fixed!)
                  </del> */}
                  &nbsp;&nbsp;
                  {/* <del>
                  
                  February 29, 2025
                  
                  </del> */}
                  {/* <br/> */}
                  {/* <del>
                    <span className="font-red">
                    March 17, 2025
                    </span >
                  </del> */}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <del></del>
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                    
                    Notification of acceptance

                    
                    </del>
                </td>
                <td>
                  {/* <del> */}
                    <del>

                  May 1st, 2025
                    </del>
                    
                    {/* </del> */}
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                    
                    Camera-ready copy

                    
                    </del>
                </td>
                <td>
                  <del>
                    
                  June 1st, 2025

                    
                    </del>
                </td>
              </tr>
              <tr>
                <td>
                  <del>
                    
                    Author registration

                    
                    </del>
                </td>
                <td>
                  <del>
                    
                June 1st, 2025

                    
                    </del>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    
                    Public registration

                    
                    </strong>
                </td>
                <td>
                  <strong>
                    
                July 11th, 2025

                    
                    </strong>
                </td>
              </tr>

            </tbody>
          </table>
          {/* <div className="row">
            <h5>Click the link below to submit your paper to ICSI 2022</h5>
            <a
              className="btn btn-primary"
              href="https://easychair.org/conferences/?conf=icsi2022"
            >
              ICSI Online Paper Submission
            </a>
          </div> */}
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
        <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Deadlines;
